/**
 * MagicEdenStakingPromotion Component
 *
 * Promotional banner shown above/near the Connect Wallet button
 * Promotes Magic Eden $ME staking for earning 2x points
 *
 * Only visible when:
 * - Campaign is active
 * - User is NOT connected OR is connected but not a $ME staker
 */

import { useMagicEdenCampaign } from '@/hooks/useMagicEdenCampaign';

export function MagicEdenStakingPromotion() {
  const { campaignData, isLoading } = useMagicEdenCampaign();

  // Show if campaign is active and user is not a staker
  if (isLoading || !campaignData?.isActive || campaignData?.isMagicEdenStaker) {
    return null;
  }

  return (
    <div
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full animate-pulse-subtle"
      style={{
        background: 'linear-gradient(92deg, #E42575 -4.02%, #7950F2 50.55%, #E42575 103.05%)',
        fontFamily: 'Outfit, sans-serif',
        fontSize: '11px',
        fontWeight: 700,
        color: '#FFFFFF',
        boxShadow: '0 0 15px rgba(228, 37, 117, 0.4)',
      }}
    >
      {/* Magic Eden Logo */}
      <img
        src="/Magic Eden.png"
        alt="Magic Eden"
        className="w-4 h-4 object-contain"
      />
      <span className="whitespace-nowrap">$ME STAKERS: 2x Points!</span>
    </div>
  );
}
